export default __webpack_public_path__ + "static/media/partners-logo-ewha-w@2x.032cf289.webp";